module.exports = __webpack_public_path__ + "media/src/images/proctored_icons/no_pause-951fa834ae752073a31178e118440b37.svg";